/* src/app/views/dashboard/components/sidebar-nav/nav-sub-item/products-sub-nav-item/products-sub-nav-item.component.scss */
/*# sourceMappingURL=products-sub-nav-item.component.css.map */
